<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="football" alt="football" src="../../assets/images/19a-lrn-spt-cat-2-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>Your request for a trial subscription has been sent!<br />
        Thank you for your interest in Lerner Sports!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'RegisterAcknowledge',

    components: {
      Acknowledge,
    },

    data: function () {
      return {
        headline: 'Touchdown!',
      }
    }
  };
</script>